// Pages
import {
  AppBar,
  Autocomplete,
  Avatars,
  BackendError,
  Badges,
  Blank,
  ButtonNavigation,
  Buttons,
  Calendar,
  Cards,
  Charts,
  Chat,
  Chips,
  Detail,
  Dialogs,
  Dividers,
  Drawers,
  Editor,
  ExpansionPanels,
  Google,
  GridList,
  Home,
  Invoice,
  Leaflet,
  Lists,
  Lockscreen,
  Media,
  Menus,
  Messages,
  NotFound,
  Paper,
  PasswordReset,
  Pickers,
  PricingPage,
  Progress,
  SelectionControls,
  Selects,
  Signin,
  Signup,
  Snackbars,
  Social,
  Steppers,
  Tables,
  Tabs,
  Taskboard,
  TextFields,
  TimelinePage,
  Tooltips,
  Widgets,
  // Orders,
  ManageUsers,
  AddUser,
  Vendors,
} from './pages';


import AppsIcon from '@material-ui/icons/Apps';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import EqualizerIcon from '@material-ui/icons/Equalizer';
// Icons
import ExploreIcon from '@material-ui/icons/Explore';
import FaceIcon from '@material-ui/icons/Face';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import Looks3Icon from '@material-ui/icons/Looks3';
import Looks4Icon from '@material-ui/icons/Looks4';
import NavigationIcon from '@material-ui/icons/Navigation';
import PagesIcon from '@material-ui/icons/Pages';
import PersonIcon from '@material-ui/icons/Person';
import PhotoIcon from '@material-ui/icons/Photo';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import StoreIcon from '@material-ui/icons/Store';
import CategoryIcon from '@material-ui/icons/Category';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import LocationOn from '@material-ui/icons/LocationOn';

// Vendors
import EditVendor from './pages/Vendors/EditVendor';

// Manage Categories
import ManageCategories from './pages/Categories/ManageCategories';

// Profile
import Profile from './pages/Profile/Profile';
import EditProfile from './pages/Profile/EditProfile';

// Products
import ManageProducts from './pages/Store/ManageProducts';
import AddProduct from './pages/Store/AddProduct';
import EditProduct from './pages/Store/EditProduct';

// Product review
import ManageProductsReview from './pages/ProductReview/ManageProductsReview';
import EditProductReview from './pages/ProductReview/EditProductReview';

// Orders
import Orders from './pages/Orders/Orders';
import EditOrder from './pages/Orders/EditOrder';

// Terms and Conditions
import AddTermsAndConditions from './pages/TermsAndConditions/AddTermsAndConditions';
import ManageTermsAndConditions from './pages/TermsAndConditions/ManageTermsAndConditions';

// Manage Locations
import ManageLocations from './pages/Locations/ManageLocations';

// Manage Deliveries
import ManageDeliveries from './pages/Deliveries/ManageDeliveries';
import EditDelivery from './pages/Deliveries/EditDelivery';

export const routes =
  [
    {
      path: '/',
      name: 'Dashboard',
      type: 'link',
      userType: ['admin', 'vendor'],
      icon: ExploreIcon,
      component: Home
    },
    {
      path: '/profile',
      name: 'Mange Profile',
      type: 'link',
      userType: ['admin', 'vendor'],
      icon: AccountCircleIcon,
      component: Profile
    },
    {
      path: '/edit-profile',
      name: 'Edit Profile',
      type: 'hiddenMenu',
      userType: ['admin', 'vendor'],
      icon: ExploreIcon,
      component: EditProfile
    },
    {
      path: '/store',
      name: 'Manage Store',
      type: 'submenu',
      userType: ['admin', 'vendor'],
      icon: StoreIcon,
      children: [
        {
          path: '/our-store',
          name: 'Manage Products',
          component: ManageProducts
        },
        {
          path: '/add-product',
          name: 'Add Product',
          component: AddProduct
        }
      ]
    },
    {
      path: '/product-review',
      name: 'Product Review',
      type: 'link',
      userType: ['admin'],
      icon: StoreIcon,
      component: ManageProductsReview
    },
    {
      path: '/edit-product/:slug',
      name: 'Edit Product',
      type: 'hiddenMenu',
      userType: ['admin', 'vendor'],
      icon: ExploreIcon,
      component: EditProduct
    },
    {
      path: '/edit-product-review/:slug',
      name: 'Edit Product',
      type: 'hiddenMenu',
      userType: ['admin'],
      icon: ExploreIcon,
      component: EditProductReview
    },
    {
      path: '/orders',
      name: 'Manage Orders',
      type: 'link',
      userType: ['admin', 'vendor'],
      icon: ShoppingCartIcon,
      component: Orders
    },
    {
      path: '/edit-order/:orderID',
      name: 'Edit Order',
      type: 'hiddenMenu',
      userType: ['admin', 'vendor'],
      icon: ExploreIcon,
      component: EditOrder
    },
    {
      path: '/user',
      name: 'UserManagement',
      type: 'submenu',
      userType: ['admin'],
      icon: PersonAddIcon,
     
      children: [
        {
          path: '/manage-users',
          name: 'Manage Users',
          component: ManageUsers
        },
        {
          path: '/add-user',
          name: 'Add User',
          component: AddUser
        }
      ]
    },
    {
      path: '/categories',
      name: 'Manage Categories',
      type: 'link',
      userType: ['admin'],
      icon: CategoryIcon,
      component: ManageCategories
    },
    {
      path: '/vendors',
      name: 'Manage Vendors',
      type: 'link',
      userType: ['admin'],
      icon: PersonIcon,
      component: Vendors
    },
    {
      path: '/edit-vendor/:vendorID',
      name: 'Edit Vendor',
      type: 'hiddenMenu',
      userType: ['admin'],
      icon: ExploreIcon,
      component: EditVendor
    },
    {
      path: '/add-terms',
      name: 'Add Terms',
      type:'hiddenMenu',
      userType: ['admin'],
      icon: ExploreIcon,
      component: AddTermsAndConditions
    },
    {
      path: '/manage-terms-and-conditions',
      name: 'Manage Terms',
      type: 'link',
      userType: ['admin'],
      icon: PersonIcon,
      component: ManageTermsAndConditions
    },
    {
      path: '/locations',
      name: 'Manage Locations',
      type: 'link',
      userType: ['admin'],
      icon: LocationOn,
      component: ManageLocations
    },
    {
      path: '/deliveries',
      name: 'Manage Deliveries',
      type: 'link',
      userType: ['admin'],
      icon: LocationOn,
      component: ManageDeliveries
    } 
];

export default routes;

